// lib
import moment from "moment";

export const getVisibleRange = (focus, view) => {
  switch (view) {
    case "day": {
      return [moment(focus).startOf("day").valueOf(), moment(focus).endOf("day").valueOf()];
    }
    case "threeDays": {
      return [
        moment(focus).startOf("day").valueOf(),
        moment(focus).endOf("day").add(2, "d").valueOf(),
      ];
    }
    case "fiveDays": {
      return [
        moment(focus).startOf("week").valueOf(),
        moment(focus).endOf("week").subtract(2, "d").valueOf(),
      ];
    }
    case "week": {
      return [moment(focus).startOf("week").valueOf(), moment(focus).endOf("week").valueOf()];
    }
    case "month": {
      return [moment(focus).startOf("month").valueOf(), moment(focus).endOf("month").valueOf()];
    }
    case "timeline": {
      // by default, can be changed interacting with timeline
      return [
        moment(focus).startOf("day").add(8, "h").valueOf(),
        moment(focus).endOf("day").add(8, "h").valueOf(),
      ];
    }
    default:
      return null;
  }
};

export const getTrackedRange = (focus, view) => {
  if (["day", "threeDays", "fiveDays", "week"].includes(view)) return getVisibleRange(focus, view);

  if (view === "month") {
    return [
      moment(focus).startOf("week").startOf("month").add(1, "m").startOf("week").valueOf(),
      moment(focus).endOf("week").endOf("month").subtract(1, "m").endOf("week").valueOf(),
    ];
  }
  if (view === "timeline") {
    return [
      moment(focus).startOf("day").subtract(7, "d").valueOf(),
      moment(focus).endOf("day").add(14, "d").valueOf(),
    ];
  }
  return null;
};

// Returns a focus in wished view range
export const updateFocusInView = ({ focus, dateStart, view }, { newDateEnd, newDateStart }) => {
  if (view === "timeline") return dateStart; // used to be focus;
  const newDateCenter = moment(Math.ceil(newDateStart + (newDateEnd - newDateStart) / 2)).valueOf();
  const rangeFrom = view === "month" ? newDateCenter : newDateStart;
  // true minimal wished range, getRange supposed to act on date start / exception for month
  const [rangeDateStart, rangeDateEnd] = getVisibleRange(rangeFrom, view);
  // if old focus in new range, let's keep it
  if (focus < rangeDateStart || focus > rangeDateEnd) {
    if (view === "month") {
      // set to first of the month
      return moment(newDateCenter).startOf("month").valueOf();
    }
    // stay on the given day of the week/range
    let newFocus = newDateStart + focus - dateStart;
    if (newFocus < newDateStart || newFocus > newDateEnd) {
      newFocus = newDateCenter;
    }
    return newFocus;
  }
  return focus;
};
